import reducerRegistry from 'core/lib/store/reducer-registry';
import {
  GET_PERMISSION,
  GET_PERMISSION_SUCCESS,
  GET_PERMISSION_ERROR
} from "../action-types/userInfo";
import api from '../apis/pc/setMessage/setMessage'
import permissionListReducer from '../reducers/permission'

reducerRegistry.register('permissionList', permissionListReducer)

export function getPermissionList() {
  return {
    types: [GET_PERMISSION, GET_PERMISSION_SUCCESS, GET_PERMISSION_ERROR],
    callAPI: () => api.getUserRoleList(),
  };
}
